module.exports = __webpack_public_path__ + "static/assets/ec2b39e46cb4e1ee41e6ed8a8c6ee1a8.png";